import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import Visibility from '@material-ui/icons/Visibility';

import { DialogForm } from '../DialogForm';
import AddUserFormDataConfig, { EditUserFormDataConfig } from './userFormDataConfig';
import { ADD_USER, FETCH_USER_ROLE } from '../../containers/graphQL/queries';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  dialog: {
    width: '100%'
  },
  dialogTitle: {
    padding: theme.spacing(2),
    borderBottom: '1px solid'
  },
  progress: {
    color: theme.palette.background.paper
  },
  textField: {
    width: '80%'
  },
  grid: {
    width: '100%',
    borderBottom: '1px solid #EBEBEB'
  },
  headers: {
    color: theme.palette.text.secondary
  },
  margin: {
    marginTop: '25px',
    marginRight: '2vh',
    float: 'right',
    '&:disabled': {
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      opacity: 0.5
    }
  }
}));

interface AddUserDialog {
  handleDialogOpen?: any;
  handledialogclose?: any;
  edit?: true | false;
  formData?: any;
  handleDialogSubmit?: any;
  formInfo?: any;
  refresh?: any;
  dialogOpen?: true | false;
  usersData?: any;
}

let dataConfig = [...AddUserFormDataConfig];

const AddUserDialog = (props: AddUserDialog) => {
  const [addUser] = useMutation(ADD_USER);
  const [loader, setLoader] = useState(false);
  const [formValidated, setFormValidated] = useState(false);
  const [formError, setFormError] = useState(false);
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [fetchUserRole] = useMutation(FETCH_USER_ROLE);
  const classes = useStyles();
  const { edit, formData, usersData } = props;
  const [formInfo, setFormInfo] = React.useState<any>({});

  const { enqueueSnackbar } = useSnackbar();

  let icon = <Visibility />;

  useEffect(() => {
    if (props.edit) {
      setFormError(false);
      setFormErrorMsg('');
      const editData: any[] = [];
      let roleObj: { [x: string]: any } = {};

      let role;
      formData &&
        formData.tenantRoles &&
        formData.tenantRoles.map((item: { roleType: any }, index: number) => {
          if (index == 0) role = item.roleType;
        });
      roleObj['userType'] = role;

      setFormInfo({ ...formData, ...roleObj });
    } else {
      const editData: any[] = [];
      (dataConfig || []).forEach((obj: any) => {
        let temp = { ...obj };
        if (temp.key === 'userName') {
          temp.InputProps = {};
        }
        editData.push(temp);
      });
      dataConfig = [...editData];
      setFormInfo({
        ...props.formInfo
      });
    }
  }, [formData, edit, props.formInfo]);

  const submitUserData = (formDataObj: any) => {
    props.handleDialogSubmit();
    addUser({
      variables: {
        userName: edit ? formDataObj.userName : `${formDataObj.userName}@${formDataObj.domainName}`,
        firstName: formDataObj.firstName,
        lastName: formDataObj.lastName,
        userType: formDataObj?.userType,
        status: 'ACTIVE',
        method: edit ? 'POST' : 'POST'
      }
    })
      .then(response1 => {
        enqueueSnackbar(edit ? 'Modified User Details successfully !!' : 'Added User successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        props.refresh();
        return response1;
      })
      .catch(() => {
        enqueueSnackbar(edit ? 'Modified User Details failed' : 'Add User failed !!', {
          variant: 'error',
          preventDuplicate: true
        });
        if (edit) {
          props.refresh();
        }
      });
  };

  const getLatestValues = (dataObj: any) => {
    const editData: any[] = [];
    (dataConfig || []).forEach((obj: any) => {
      let temp = { ...obj };
      if (temp.key === 'userType') {
        temp.defaultValue = dataObj?.userType;
      }
      editData.push(temp);
    });
    dataConfig = [...editData];
    setFormInfo(dataObj);
  };

  const validateUser = (formDataObj: any) => {
    if (formDataObj?.domainName !== undefined && formDataObj?.userName !== undefined) {
      let userName = `${formDataObj.userName}@${formDataObj.domainName}`;
      let filteredUsers = usersData?.length && usersData.filter((item: any) => item.userName === userName);
      setLoader(true);
      if (filteredUsers && filteredUsers.length >= 1) {
        setFormValidated(false);
        setFormError(true);
        setFormErrorMsg('User Already Exist');
        setLoader(false);
      } else {
        setLoader(false);
        setFormError(false);
        setFormValidated(true);
        submitUserData(formDataObj);
      }
      const editData: any[] = [];
      (dataConfig || []).forEach((obj: any) => {
        let temp = { ...obj };
        temp.defaultValue = formDataObj && formDataObj[temp.key];
        editData.push(temp);
      });
      dataConfig = [...editData];
    }
  };

  return (
    <React.Fragment>
      <DialogForm
        key={edit ? 'edit-user-dialog' : 'new-user-dialog'}
        openFn={props.dialogOpen}
        closeFn={props.handledialogclose}
        dataConfig={edit ? [...EditUserFormDataConfig] : dataConfig}
        handleDialogClose={props.handledialogclose}
        handleDialogSubmit={edit ? submitUserData : validateUser}
        submitlabel={'Submit User Details'}
        dialogId={'new-user-dialog'}
        title={edit ? 'Edit User Details' : 'Create User'}
        data={formInfo}
        getLatestValues={getLatestValues}
        loading={loader}
        formError={formError}
        formErrorMsg={formErrorMsg}
      ></DialogForm>
    </React.Fragment>
  );
};

export default AddUserDialog;
